import { QuoteSummaryDto } from "api/quote";
import { GenericColors } from "enums/genericColors";
import { QuoteTableRowKey } from "../types/enums";
import { QuoteRow } from "../types/interfaces";
import { toDayInput } from 'core/utils/dates';

export function mapQuoteSummary(quoteSummary: QuoteSummaryDto): QuoteRow {
  const getQuoteContract = () => {
    if (quoteSummary.quoteIdentifier) {
      return quoteSummary.quoteIdentifier
    }

    if (quoteSummary.contractIdentifier) {
      return quoteSummary.contractIdentifier
    }

    return {
      id: '_', label: '_'
    }
  }
  const quoteContract = getQuoteContract();
  return {
    id: quoteContract.id || quoteSummary.riskId || '',
    riskId: quoteSummary.riskId || '',
    borrowerProjectId: quoteSummary.borrowerProjectId || '',
    [QuoteTableRowKey.DATE]: quoteSummary.date.toISOString(),
    [QuoteTableRowKey.STATUS]: {
      color: quoteSummary.statusColor as GenericColors,
      label: quoteSummary.statusLabel
    },
    [QuoteTableRowKey.PRODUCT]: quoteSummary.product || '_',
    [QuoteTableRowKey.OWNER]: quoteSummary.owner,
    [QuoteTableRowKey.INSUREDS]: quoteSummary.insureds ? quoteSummary.insureds.map(item => item.label).join(', ') : '',
    [QuoteTableRowKey.CLIENT_PRICE]: `${quoteSummary.clientPrice?.toFixed(2).toString()} €` || '_',
    [QuoteTableRowKey.QUOTE_IDENTIFIER]: quoteContract,
    [QuoteTableRowKey.SUPPORT]: quoteSummary.support || '_',
    [QuoteTableRowKey.UNREAD_NOTIFICATION_COUNT]: quoteSummary.unreadNotificationCount || 0,
    // Métadonnées optionnelles (absentes si null côté back)
    productLabel: quoteSummary.productLabel ?? undefined,
    tunnelLabel: quoteSummary.tunnelLabel ?? undefined,
    // Dates calendaires : jour "yyyy-MM-dd" sans conversion de fuseau (jamais toISOString)
    effectiveDate: quoteSummary.effectiveDate ? toDayInput(quoteSummary.effectiveDate) : undefined,
    endDate: quoteSummary.endDate ? toDayInput(quoteSummary.endDate) : undefined,
  };
}

export function mapQuoteSummaries(quoteSummaries: QuoteSummaryDto[]): QuoteRow[] {
  return quoteSummaries.map(mapQuoteSummary);
}
